jQuery( function ( $ ) {

  // modal
  const $modal = $( '#mag-speaker-modal' );
  if ( $modal.length ) {
    const $replace_els = {};
    [ '.name', '.job-titles', '.sessions', '.social', '.bio', '.thumbnail' ].forEach( key => {
      $replace_els[ key ] = $( key, $modal );
    })

    $modal.on( 'show.bs.modal', e => {
      const $speaker = $( e.relatedTarget ).closest( '.speaker' );
      Object.entries( $replace_els ).forEach( entry => {
        const [ selector, $el ] = entry;
        $el.html( $( selector, $speaker ).html() );
      });
    });
  }


  // load more
  $( 'section.speakers .load-more' ).on( 'click', function () {
    const $button = $(this);
    $button.prop( 'disabled', true );
    let next_page = $button.data( 'next-page' );

    ThemeJS.Functions.wp_rest_request({
      endpoint: 'magnet/speakers/load',
      data: {
        page: next_page,
      },
      success ( response ) {
        const $list = $button.closest( '.items-wrap' ).find( '> ul' );
        response.items.forEach( ( item, index ) => {
          const $item = $(item).addClass( 'new' );
          $list.append( $item );
          setTimeout( function () {
            requestAnimationFrame(() => {
              setTimeout(() => {
                $item.removeClass( 'new' );
              });
            });
          }, index * 150 );
        });
        next_page++;
        $button.data( 'next-page', next_page );
        if ( next_page > parseInt( response.max_page ) ) {
          $button.remove();
        }
      },
      complete () {
        $button.prop( 'disabled', false );
      }
    })
  });


});